import { render, staticRenderFns } from "./BannerImageComponent.vue?vue&type=template&id=161fcdd8&lang=pug&"
import script from "./BannerImageComponent.vue?vue&type=script&lang=js&"
export * from "./BannerImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./BannerImageComponent.vue?vue&type=style&index=0&id=161fcdd8&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161fcdd8')) {
      api.createRecord('161fcdd8', component.options)
    } else {
      api.reload('161fcdd8', component.options)
    }
    module.hot.accept("./BannerImageComponent.vue?vue&type=template&id=161fcdd8&lang=pug&", function () {
      api.rerender('161fcdd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/BannerImageComponent.vue"
export default component.exports